import { useNavigate } from "react-router-dom";
import { fmtCurrency, fmtDate } from "@/lib/format";
import { StatusBadge } from "@/components/common/ui-kit";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { ArrowUpDown } from "lucide-react";

const SortHead = ({ label, k, f, set, className }) => (
  <TableHead className={className}>{set ? <button className="inline-flex items-center gap-1 hover:text-ink" onClick={() => set({ sort: k, dir: f.sort === k && f.dir === "desc" ? "asc" : "desc" })} data-testid={`opp-sort-${k}`}>
    {label}<ArrowUpDown className="h-3 w-3" /></button> : label}</TableHead>
);

export const OpportunityTable = ({ items, f, set, hideCompany }) => {
  const nav = useNavigate();
  return (
    <Table data-testid="opportunities-table">
      <TableHeader><TableRow>
        <SortHead label="Opportunità" k="title" f={f} set={set} /><TableHead>Fase</TableHead>
        <SortHead label="Valore" k="value" f={f} set={set} className="text-right" /><SortHead label="Pesato" k="weighted_value" f={f} set={set} className="text-right" />
        <SortHead label="Chiusura" k="expected_close_at" f={f} set={set} /><TableHead>Responsabile</TableHead>
        <SortHead label="Prossima azione" k="next_action_at" f={f} set={set} />
      </TableRow></TableHeader>
      <TableBody>
        {items.map((o) => (
          <TableRow key={o.id} className="cursor-pointer" onClick={() => nav(`/opportunita/${o.id}`)} data-testid={`opp-row-${o.id}`}>
            <TableCell><p className="font-semibold text-ink">{o.title}</p>{!hideCompany && <p className="text-xs text-slate-500">{o.company_name}{o.is_demo && <span className="ml-2 font-semibold uppercase text-slate-400">demo</span>}</p>}</TableCell>
            <TableCell><StatusBadge tone={o.stage?.tone || "neutral"}>{o.stage?.name}</StatusBadge></TableCell>
            <TableCell className="text-right text-sm font-semibold text-ink">{fmtCurrency(o.value)}</TableCell>
            <TableCell className="text-right text-sm text-slate-600">{fmtCurrency(o.weighted_value)} <span className="text-xs text-slate-400">({o.probability}%)</span></TableCell>
            <TableCell className="text-sm text-slate-600">{fmtDate(o.expected_close_at)}</TableCell>
            <TableCell className="text-sm text-slate-700">{o.owner_name || "—"}</TableCell>
            <TableCell>{o.status !== "open" ? <span className="text-xs text-slate-400">—</span> : o.next_action
              ? <span className={o.followup_overdue ? "text-sm font-semibold text-red-600" : "text-sm text-slate-700"}>{fmtDate(o.next_action_at)} · {o.next_action.title}</span>
              : <StatusBadge tone="amber" dot={false}>Da pianificare</StatusBadge>}</TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
};
